import moment from 'moment';
import LocalStorage from './localStorage';

export const FOLLOW_UP_STATUS_TYPES = {
  completed: 'completed',
  pending: 'pending',
  overdue: 'overdue'
};

export const NOTIFICATION_TYPE = {
  ad_hoc: 'ad-hoc_task',
  escalate: 'escalate_task'
};

export const getLoggedInUser = () => {
  const loginUser = LocalStorage.getItem('Trackex_user') || '';
  const user = loginUser || { user: null };
  return {
    ...user,
    loggedIn: loginUser !== ''
  };
};

export const getFormattedDateToSend = (date = new Date()) => {
  return moment(date).format('YYYY-MM-DD');
};

export const getFormattedDateToDisplay = (date = new Date()) => {
  return moment(date).format('MMM D (ddd)');
};

export const getNextBusinessDate = (date, option) => {
  const momentDate = moment(date);

  let daysToAdd = 0;

  switch (option) {
    case 'Tomorrow':
      daysToAdd = 1;
      break;
    case 'After 3 Days':
      daysToAdd = 3;
      break;
    case 'Next Week':
      daysToAdd = 5;
      break;
    case 'Two Weeks':
      daysToAdd = 10;
      break;
    default:
      throw new Error('Invalid option selected');
  }

  let addedDays = 0;
  while (addedDays < daysToAdd) {
    momentDate.add(1, 'days');
    const day = momentDate.day();
    if (day !== 0 && day !== 6) {
      addedDays++;
    }
  }
  return momentDate;
};

// column renderer for table
export const columnRenderer = (text, classes, nullvalue = '-') => {
  return (
    <p
      className={`${classes} text-xs m-0 p-0`}
      style={{ fontFamily: 'SFProText Bold' }}
    >
      {text || nullvalue}
    </p>
  );
};

// header renderer for table
export const headerRenderer = (text, classes, nullvalue = '-') => {
  return (
    <label
      className={`${classes} text-xs lg:text-sm font-bold`}
      style={{ fontFamily: 'SFProText Bold' }}
    >
      {text || nullvalue}
    </label>
  );
};
